<template>
  <div>
    <div v-if="enterprise" class="mb-10">
      <back-button :backURL="backURL" :title="title" />
    </div>
    <v-skeleton-loader
      v-else
      max-width="300px"
      type="text"
    ></v-skeleton-loader>

    <div v-if="windowWidth <= 768 && enterprise">
      <v-bottom-navigation
        grow
        v-model="bottomNav"
      >
        <router-link v-for="button in firstRowBtns" tag="v-btn" :key="button.name" :to="{ name: buildRoute(button.route) }">
          <span>{{ button.title }}</span>
          <v-icon>{{ button.icon }}</v-icon>
        </router-link>
      </v-bottom-navigation>
      <v-bottom-navigation
        grow
        v-model="bottomNav2"
      >
        <router-link v-for="button in secondRowBtns" tag="v-btn" :key="button.name" :to="{ name: buildRoute(button.route) }">
          <span>{{ button.title }}</span>
          <v-icon>{{ button.icon }}</v-icon>
        </router-link>
      </v-bottom-navigation>
      <v-bottom-navigation
        grow
        v-model="bottomNav3"
      >
        <router-link v-for="button in thirdRowBtns" tag="v-btn" :key="button.name" :to="{ name: buildRoute(button.route) }">
          <span>{{ button.title }}</span>
          <v-icon>{{ button.icon }}</v-icon>
        </router-link>
      </v-bottom-navigation>
    </div>
    <div v-else-if="windowWidth >= 768 && enterprise">
      <v-bottom-navigation
        grow
        v-model="bottomNav"
      >
        <router-link v-for="button in desktopNav" :active-class="`profile-option ${profileColor}`"
          tag="v-btn" :key="button.name" :to="{ name: buildRoute(button.route) }">
          <span>{{ button.title }}</span>
          <v-icon>{{ button.icon }}</v-icon>
        </router-link>
      </v-bottom-navigation>
    </div>
    <v-skeleton-loader
      v-else
      class="mx-auto mb-10"
      type="image"
    ></v-skeleton-loader>
    <transition
      name="fade"
      mode="out-in"
    >
        <router-view v-if="enterprise" class="mb-10" />
      <v-skeleton-loader
        v-else
        class="mx-auto mb-10"
        type="image"
      ></v-skeleton-loader>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BackButton from '~/components/BackButton';

export default {
  metaInfo() {
    return { title: this.$t('enterprises') };
  },
  name: 'EnterpriseProfile',
  props: {
    dealerId: { required: false },
    enterpriseId: { required: true },
  },
  components: {
    BackButton,
  },
  data: () => ({
    bottomNav: 'profileEnterprise',
    bottomNav2: '',
    bottomNav3: '',
    firstRowBtns: [
      {
        route: 'enterprise.profileEnterprise',
        name: 'profileEnterprise',
        title: 'Perfil',
        icon: 'mdi-account',
      },
      {
        route: 'enterprise.users',
        name: 'users',
        title: 'Usuarios',
        icon: 'mdi-account-key',
      },
      {
        route: 'enterprise.integration',
        name: 'integration',
        title: 'Integración',
        icon: 'mdi-key',
      },
      {
        route: 'enterprise.numeration',
        name: 'numeration',
        title: 'Numeraciones',
        icon: 'fas fa-book ',
      },
    ],
    secondRowBtns: [
      {
        route: 'enterprise.server',
        name: 'server',
        title: 'Servidor',
        icon: 'mdi-server',
      },
      {
        route: 'enterprise.templates',
        name: 'templates',
        title: 'PDF',
        icon: 'mdi-file-pdf',
      },
      {
        route: 'enterprise.templates.subject',
        name: 'templates-subject',
        title: 'Personalizar Correo',
        icon: 'mdi-email',
      },
      {
        route: 'enterprise.providers',
        name: 'providers',
        title: 'Proveedores',
        icon: 'mdi-phone',
      },
    ],
    thirdRowBtns: [
      {
        route: 'enterprise.payment',
        name: 'payment_button',
        title: 'Botón de Pago',
        icon: 'mdi-credit-card-fast',
      },
      {
        route: 'enterprise.numeration_payroll',
        name: 'numeration_payroll',
        title: 'Num. Nómina',
        icon: 'fas fa-address-book ',
      },
      {
        route: 'enterprise.licences',
        name: 'licences',
        title: 'Paquetes',
        icon: 'mdi-credit-card',
      },
      {
        route: 'enterprise.serie',
        name: 'serie',
        title: 'Series',
        icon: 'fas fa-list-ol',
      },
    ],
  }),
  computed: {
    enterprise() {
      return this.$store.state.profile.enterprise;
    },
    windowWidth() {
      return this.$store.state.window.width;
    },
    desktopNav() {
      return this.firstRowBtns.concat(this.secondRowBtns).concat(this.thirdRowBtns);
    },
    title() {
      return `Empresa <b style="text-transform:capitalize">${this.enterprise.name}</b> - R.I.F. ${this.enterprise.rif}`;
    },
    backURL() {
      if (this.dealerId) {
        return null;
      }
      return 'enterprises';
    },
    ...mapGetters({
      profileColor: 'theme/profileColor',
    }),
  },
  methods: {
    buildRoute(route) {
      if (this.dealerId) {
        return `dealers.${route}`;
      }
      return route;
    },
  },
  created() {
    this.$store.dispatch('profile/resetEnterprise');
  },
  async mounted() {
    window.axios.get(`/api/enterprises/${this.enterpriseId}`)
    .then((result) => {
      this.$store.dispatch('profile/setCurrentEnterprise', { enterprise: result.data });
      if (this.enterprise.type === null) {
        if (this.enterprise.payroll === 0) {
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'users'), 1);
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'integration'), 1);
          this.thirdRowBtns.splice(this.thirdRowBtns.findIndex(({ name }) => name === 'numeration_payroll'), 1);
          this.thirdRowBtns.splice(this.thirdRowBtns.findIndex(({ name }) => name === 'licences'), 1);
        }
        this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'numeration'), 1);
        this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'server'), 1);
        this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'templates'), 1);
        this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'templates-subject'), 1);
        this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'providers'), 1);
        this.thirdRowBtns.splice(this.thirdRowBtns.findIndex(({ name }) => name === 'payment_button'), 1);
        if (!this.can('usuarios_empresa')) {
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'users'), 1);
        }
        if (!this.can('integracion_empresa')) {
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'integration'), 1);
        }
        if (!this.can('numeraciones_empresa_nomina')) {
          this.thirdRowBtns.splice(this.thirdRowBtns.findIndex(({ name }) => name === 'numeration_payroll'), 1);
        }
        if (!this.can('licencias')) {
          this.thirdRowBtns.splice(this.thirdRowBtns.findIndex(({ name }) => name === 'licences'), 1);
        }
      } else {
        if (!this.can('usuarios_empresa')) {
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'users'), 1);
        }
        if (!this.can('integracion_empresa')) {
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'integration'), 1);
        }
        if (!this.can('numeraciones_empresa')) {
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'numeration'), 1);
        }
        if (!this.can('servidor_correo')) {
          this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'server'), 1);
        }
        if (!this.can('representaciones_empresa')) {
          this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'templates'), 1);
        }
        if (!this.can('personalizar_correo_empresa')) {
          this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'templates-subject'), 1);
        }
        if (!this.can('proveedores')) {
          this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'providers'), 1);
        }
        if (!this.can('boton_de_pago')) {
          this.thirdRowBtns.splice(this.thirdRowBtns.findIndex(({ name }) => name === 'payment_button'), 1);
        }
        if (!this.can('numeraciones_empresa_nomina')) {
          this.thirdRowBtns.splice(this.thirdRowBtns.findIndex(({ name }) => name === 'numeration_payroll'), 1);
        }
        if (!this.can('licencias')) {
          this.thirdRowBtns.splice(this.thirdRowBtns.findIndex(({ name }) => name === 'licences'), 1);
        }
        if (this.enterprise.payroll === 0) {
          this.thirdRowBtns.splice(this.thirdRowBtns.findIndex(({ name }) => name === 'numeration_payroll'), 1);
          this.thirdRowBtns.splice(this.thirdRowBtns.findIndex(({ name }) => name === 'licences'), 1);
        }
        if (!this.can('series_empresa')) {
          this.thirdRowBtns.splice(this.thirdRowBtns.findIndex(({ name }) => name === 'serie'), 1);
        }
      }
    });
  },
};
</script>
